import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      <section className="pt-36 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-4 block">
            Protection des données
          </span>
          <h1 className="text-4xl font-bold text-navy-800">
            Politique de confidentialité
          </h1>
          <p className="text-gray-400 text-sm mt-3">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="space-y-10">

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="introduction">
                <a href="#introduction" className="text-navy-800">Introduction</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                KRUTAK, représenté par Maria Ruta Krutak, s'engage à protéger la vie privée des utilisateurs du site. Cette politique de confidentialité explique quelles données sont collectées, comment elles sont utilisées et quels sont vos droits.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="donnees">
                <a href="#donnees" className="text-navy-800">Données collectées</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed mb-4">
                Dans le cadre de l'utilisation du formulaire de contact, le site peut collecter les données personnelles suivantes :
              </p>
              <ul className="space-y-2">
                {['Nom et prénom', 'Adresse email', 'Numéro de téléphone', 'Message / Description de la demande'].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-gray-600 text-[15px]">
                    <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="utilisation">
                <a href="#utilisation" className="text-navy-800">Utilisation des données</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed mb-4">
                Les données personnelles collectées sont utilisées exclusivement pour :
              </p>
              <ul className="space-y-2">
                {[
                  'Répondre aux demandes de contact ou d\'information',
                  'Assurer le suivi des échanges commerciaux',
                  'Respecter les obligations légales en vigueur',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-gray-600 text-[15px]">
                    <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="partage">
                <a href="#partage" className="text-navy-800">Partage des données</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Les données personnelles collectées ne sont <strong>ni vendues, ni cédées, ni partagées</strong> avec des tiers, sauf obligation légale. Elles sont traitées de manière confidentielle par KRUTAK uniquement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="conservation">
                <a href="#conservation" className="text-navy-800">Conservation des données</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Les données sont conservées uniquement le temps nécessaire pour répondre à la demande ou selon les délais légaux applicables. Elles sont ensuite supprimées de manière sécurisée.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="droits">
                <a href="#droits" className="text-navy-800">Vos droits (RGPD)</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed mb-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              </p>
              <ul className="space-y-2">
                {[
                  'Droit d\'accès à vos données',
                  'Droit de rectification de vos données',
                  'Droit à l\'effacement (« droit à l\'oubli »)',
                  'Droit à la limitation du traitement',
                  'Droit d\'opposition au traitement',
                  'Droit à la portabilité des données',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-gray-600 text-[15px]">
                    <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-gray-600 text-[16px] leading-relaxed mt-4">
                Pour exercer ces droits, vous pouvez nous contacter par email à :{' '}
                <a href="mailto:mariakrutak02@inbox.eu" className="text-navy-700 underline cursor-pointer">
                  mariakrutak02@inbox.eu
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="cookies">
                <a href="#cookies" className="text-navy-800">Cookies</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Ce site n'utilise pas de cookies de traçage ou publicitaires. Des cookies techniques peuvent être utilisés pour le bon fonctionnement du site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="contact-rgpd">
                <a href="#contact-rgpd" className="text-navy-800">Contact – Protection des données</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Pour toute question relative à la protection de vos données personnelles :<br />
                <strong>KRUTAK</strong> – Maria Ruta Krutak<br />
                23 Rue Nationale, 59800 Lille, France<br />
                <a href="mailto:mariakrutak02@inbox.eu" className="text-navy-700 underline cursor-pointer">
                  mariakrutak02@inbox.eu
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
